module.exports = __webpack_public_path__ + "img/8_hills.1bd3c663.jpg";